import type { IconProps } from './icons';
import { createSvgIcon } from './icons';

export default function MenuIcon(props: IconProps) {
    const svg = <svg xmlns="http://www.w3.org/2000/svg" height="100%" viewBox="0 -960 960 960" width="100%" fill="#currentColor">
                    <path d="M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z"/>
                </svg>;
    return (
        createSvgIcon(svg, props)
    );
}

